// Generated on 2026-07-14T20:30:32.689Z
// This file contains preloaded products top brands data from the API
// Do not edit manually - use 'npm run generate:products-top-brands-data' to regenerate

export const preloadedProductsTopBrands: any = [
  {
    "marca": "DORMAN",
    "cantidadProductosVendidos": "52155"
  },
  {
    "marca": "NAKAMOTO",
    "cantidadProductosVendidos": "38634"
  },
  {
    "marca": "GSP NORTH AMERICA",
    "cantidadProductosVendidos": "37382"
  },
  {
    "marca": "WAGNER QUICKSTOP",
    "cantidadProductosVendidos": "28840"
  },
  {
    "marca": "FEBEST",
    "cantidadProductosVendidos": "25974"
  },
  {
    "marca": "ONNURI",
    "cantidadProductosVendidos": "24405"
  },
  {
    "marca": "VALVOLINE",
    "cantidadProductosVendidos": "23925"
  },
  {
    "marca": "BANDO",
    "cantidadProductosVendidos": "22735"
  },
  {
    "marca": "DENSO",
    "cantidadProductosVendidos": "20409"
  },
  {
    "marca": "DNJ",
    "cantidadProductosVendidos": "19285"
  },
  {
    "marca": "MAHLE ORIGINAL",
    "cantidadProductosVendidos": "18965"
  },
  {
    "marca": "BECK/ARNLEY",
    "cantidadProductosVendidos": "16219"
  },
  {
    "marca": "ECOGARD",
    "cantidadProductosVendidos": "14706"
  },
  {
    "marca": "FAG",
    "cantidadProductosVendidos": "12688"
  },
  {
    "marca": "555",
    "cantidadProductosVendidos": "12684"
  },
  {
    "marca": "BLUE PRINT",
    "cantidadProductosVendidos": "12589"
  },
  {
    "marca": "PRESTONE",
    "cantidadProductosVendidos": "11932"
  },
  {
    "marca": "DAYCO",
    "cantidadProductosVendidos": "11591"
  },
  {
    "marca": "PT",
    "cantidadProductosVendidos": "11080"
  },
  {
    "marca": "MOTORAD",
    "cantidadProductosVendidos": "10119"
  },
  {
    "marca": "MOOG",
    "cantidadProductosVendidos": "9994"
  },
  {
    "marca": "TENACITY",
    "cantidadProductosVendidos": "9926"
  },
  {
    "marca": "HS",
    "cantidadProductosVendidos": "8823"
  },
  {
    "marca": "MOOG EU",
    "cantidadProductosVendidos": "8727"
  },
  {
    "marca": "STANDARD/INTERMOTOR",
    "cantidadProductosVendidos": "8615"
  },
  {
    "marca": "WAGNER",
    "cantidadProductosVendidos": "8323"
  },
  {
    "marca": "NATIONAL",
    "cantidadProductosVendidos": "8296"
  },
  {
    "marca": "WALKER",
    "cantidadProductosVendidos": "8133"
  },
  {
    "marca": "DORMAN PREMIUM",
    "cantidadProductosVendidos": "8023"
  },
  {
    "marca": "EAGLE BHP",
    "cantidadProductosVendidos": "7298"
  }
];

export default preloadedProductsTopBrands;
